export class MimeType {

  static ALLOWED_TYPES = [
    ".pdf",
    ".mp4",
    ".docx",
    ".pptx",
    ".xlsx"
  ];

  static __data: Record<string, Record<string, string>> = {
    "application/mp4": {
      "title": "Video",
      "icon": "Audio-mp4.svg",
    },
    "video/mp4": {
      "title": "Video",
      "icon": "Audio-mp4.svg",
      "fileEnding": ".mp4"
    },
    "application/pdf": {
      "title": "PDF",
      "icon": "PDF_file_icon.svg",
      "fileEnding": ".pdf"
    },
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": {
      "title": "Microsoft Word",
      "icon": "docx_icon.svg",
      "fileEnding": ".docx"
    },
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
      "title": "Microsoft PowerPoint",
      "icon": "pptx_icon.svg",
      "fileEnding": ".pptx"
    },
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": {
      "title": "Microsoft Excel",
      "fileEnding": ".xlsx"
    },
    "image/png": {
      "title": "Image",
      "fileEnding": ".png"
    },
    "image/jpeg": {
      "title": "Image",
      "fileEnding": ".jpeg"
    }
  }

  static isVideo(mimeType: string) {
    return mimeType === "application/mp4" || mimeType === "video/mp4";
  }

  // Audio files are uploaded, then wrapped server-side into an MP4 (delivered as
  // application/mp4 and played like a video). They are only recognizable as audio
  // via their original_mime_type, e.g. "audio/mpeg".
  static isAudio(mimeType: string | null | undefined) {
    return mimeType?.startsWith("audio/") ?? false;
  }

  /* */
  static getMimeType(mimeType: string | undefined) {
    if (!mimeType) {
      return undefined;
    }

    if (mimeType === "application/mp4") {
      return "video/mp4";
    }

    return mimeType;
  }

  static getName(mimeType: string) {
    if (MimeType.isAudio(mimeType)) {
      return "Audio";
    }
    return MimeType.__data[mimeType]?.["title"] ?? mimeType;
  }

  static getIconPath(mimeType: string) {
    const icon =
      MimeType.__data[mimeType]?.["icon"] ?? MimeType.__data["application/mp4"]["icon"];
    return `/src/assets/images/${icon}`;
  }

  static allowedReplacementTypes(mimeType: string) {
    if (MimeType.isAudio(mimeType)) {
      return ["audio/*"];
    }

    if (mimeType === "application/mp4") {
      return [".mp4"];
    }

    return [".pdf", ".docx", ".pptx", ".xlsx", ".png", ".jpeg"];
  }

  static contains(allowedEndings: Array<string>, fileType: string) {
    if (allowedEndings.includes("audio/*") && MimeType.isAudio(fileType)) {
      return true;
    }
    const ending = MimeType.__data[fileType]?.fileEnding;
    return ending ? allowedEndings.indexOf(ending) !== -1 : false;
  }

}